import { AbsoluteFill } from "remotion";
import { COLORS, FONTS, Fonts } from "../../coldcompute";

/** YouTube thumbnail (1280×720). Focal subject + bold 3–4 words, high contrast, on-brand. */
export const A2uiAgentGeneratedUIThumb: React.FC = () => (
  <AbsoluteFill
    style={{
      background: `radial-gradient(95% 95% at 74% 16%, #0A1622 0%, ${COLORS.bg} 55%, ${COLORS.bg2} 100%)`,
      alignItems: "flex-start",
      justifyContent: "center",
      flexDirection: "column",
      padding: "0 84px",
    }}
  >
    <Fonts />
    {/* faint scanline grain */}
    <AbsoluteFill
      style={{
        opacity: 0.06,
        mixBlendMode: "screen",
        backgroundImage: "repeating-linear-gradient(0deg, #fff 0 1px, transparent 1px 3px)",
      }}
    />
    {/* focal subject: a hard-bordered "rendered UI card" the agent emits */}
    <div
      style={{
        position: "absolute",
        right: 40,
        top: 96,
        width: 300,
        transform: "rotate(-3deg)",
        background: COLORS.panel,
        border: `1.5px solid ${COLORS.cyan}`,
        borderRadius: 14,
        boxShadow: `0 30px 80px -30px #000, 0 0 40px -16px ${COLORS.cyan}`,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          fontFamily: FONTS.mono,
          fontSize: 15,
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          color: COLORS.cyan,
          padding: "9px 13px",
          borderBottom: `1px solid ${COLORS.line}`,
        }}
      >
        agent-rendered card
      </div>
      <div style={{ padding: "11px 13px", fontFamily: FONTS.mono, fontSize: 15, color: COLORS.text, lineHeight: 1.7 }}>
        <div style={{ color: COLORS.dim }}>type: Table · sortable</div>
        <div>type: Button</div>
        <div
          style={{
            marginTop: 12,
            display: "inline-block",
            background: COLORS.green,
            color: COLORS.bg,
            fontFamily: FONTS.display,
            fontWeight: 700,
            fontSize: 15,
            padding: "7px 13px",
            borderRadius: 8,
          }}
        >
          Email summary →
        </div>
      </div>
    </div>
    {/* honesty pill */}
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 10,
        fontFamily: FONTS.mono,
        fontSize: 22,
        letterSpacing: "0.16em",
        textTransform: "uppercase",
        color: COLORS.amber,
        border: `1px solid ${COLORS.amber}88`,
        borderRadius: 8,
        padding: "8px 16px",
        marginBottom: 22,
      }}
    >
      <span style={{ width: 11, height: 11, borderRadius: "50%", background: COLORS.amber }} />
      roadmap · how I&apos;d build it
    </div>
    <div
      style={{
        fontFamily: FONTS.display,
        fontWeight: 700,
        fontSize: 118,
        lineHeight: 0.92,
        letterSpacing: "-0.02em",
        color: COLORS.text,
        maxWidth: 820,
      }}
    >
      AI THAT SENDS
      <br />
      <span style={{ color: COLORS.cyan }}>UI, NOT TEXT</span>
    </div>
    <div
      style={{
        fontFamily: FONTS.mono,
        fontSize: 25,
        color: COLORS.dim,
        marginTop: 26,
      }}
    >
      A2UI · agent-generated interfaces · safe like data
    </div>
  </AbsoluteFill>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
